/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import BackgroundImage from '../../BackgroundImage';
import PrismicLink from '../../Links/PrismicLink';

import styles from './eventCardSponsored.scss';

class EventCardSponsored extends Component {
    render() {
        const { featuredEvent = {}, 'data-testid': dataTestId } = this.props;
        const { title, description, cta_copy, cta_link, image, overlay_percent, titlecolor, descriptioncolor } = featuredEvent;

        return (
            <div className={`utr-card ${styles.adCard}`} data-testid={dataTestId || undefined}>
                <div className={`list-view d-none d-md-block p-0`}>
                    <BackgroundImage
                        baseUrl={''}
                        defaultImage={'/img/event-image-1.jpg'}
                        images={{
                            ...image,
                            default: image && image.desktop && image.desktop.default,
                        }}
                        imageType={'desktop'}
                        backgroundOverlay={overlay_percent || true}
                        useRawSrcSet={true}
                    >
                        <div className="content-wrapper">
                            <div className="club-and-name">
                                <div style={{ color: titlecolor }} className="club-name mb16" data-testid={dataTestId && `${dataTestId}.title`}>
                                    {title}
                                </div>
                                <div style={{ color: descriptioncolor }} className={`name`} data-testid={dataTestId && `${dataTestId}.description`}>
                                    <span dangerouslySetInnerHTML={{ __html: description }} />
                                </div>
                            </div>
                            <div className="cta">
                                <PrismicLink link={cta_link} onClick={this.onClick} data-testid={dataTestId && `${dataTestId}.cta-link`}>
                                    <div className="btn btn-sm btn-white" data-testid={dataTestId && `${dataTestId}.cta-btn`}>{cta_copy}</div>
                                </PrismicLink>
                            </div>
                        </div>
                    </BackgroundImage>
                </div>
                <div className={`card-view d-block d-md-none`}>
                    <BackgroundImage
                        baseUrl={''}
                        defaultImage={'/img/event-image-1.jpg'}
                        images={{
                            ...image,
                            default: image && image.mobile && image.mobile.default,
                        }}
                        imageType={'mobile'}
                        backgroundOverlay={overlay_percent || true}
                        useRawSrcSet={true}
                    >
                        <div className="content-wrapper">
                            <div className="club-and-name">
                                <div style={{ color: titlecolor }} className="club-name mb8" data-testid={dataTestId && `${dataTestId}.m-title`}>
                                    {title}
                                </div>
                                <div style={{ color: descriptioncolor }} className={`name`} data-testid={dataTestId && `${dataTestId}.m-description`}>
                                    <span dangerouslySetInnerHTML={{ __html: description }} />
                                </div>
                            </div>
                            <div className="cta">
                                <PrismicLink link={cta_link} onClick={this.onClick} data-testid={dataTestId && `${dataTestId}.m-cta-link`}>
                                    <div className="btn btn-sm btn-white" data-testid={dataTestId && `${dataTestId}.m-cta-btn`}>{cta_copy}</div>
                                </PrismicLink>
                            </div>
                        </div>
                    </BackgroundImage>
                </div>
            </div>
        );
    }
}

EventCardSponsored.propTypes = {
    featuredEvent: PropTypes.object,
    'data-testid': PropTypes.string,
};

EventCardSponsored.defaultProps = {
    featuredEvent: {},
    'data-testid': null,
};

export default withRouter(EventCardSponsored);
